import { CodeBlock } from '@atlaskit/code';
import { IconCardGroup } from '@af/design-system-docs-ui';
import { codeAgentsInstruction, codeInstallPersonalSkill, codeInstallSkill, codeMcpConfig, codeSearchWithCli, skillCards } from "../../../../src/snippets/code/with-ai";
import * as React from 'react';
export default {
  CodeBlock,
  IconCardGroup,
  codeAgentsInstruction,
  codeInstallPersonalSkill,
  codeInstallSkill,
  codeMcpConfig,
  codeSearchWithCli,
  skillCards,
  React
};